<template>
    <div>
        <vs-popup title="Atualizar Conexão" 
            :button-close-hidden="false" 
            :active.sync="isActive"
            @close="closePopUpUpdate()"
            id="create-instance-popup"
        > 
            <div class="update-instance-modal">
                <div class="update-instance-modal__header">
                    <h5 class="update-instance-modal__title">Atualize os dados principais da conexão</h5>
                    <p class="update-instance-modal__subtitle">Altere apenas os campos necessários para evitar mudanças indevidas no estado da conexão.</p>
                </div>

                <div class="update-instance-modal__field">
                    <vs-input label="Nome da Conexão" v-model="instance.name" class="mt-2 w-full" name="tenantName"/>
                    <span class="text-danger text-sm" v-show="errors.has('tenantName')">
                        {{ errors.first('tenantName') }}
                    </span>
                </div>

                <div class="update-instance-modal__sections">
                    <div class="update-instance-section">
                        <h6 class="update-instance-section__title">Configuração</h6>

                        <div class="update-instance-option">
                            <vs-checkbox v-model="instance.is_official" size="small">
                                <span class="update-instance-option__label">Conexão Oficial</span>
                            </vs-checkbox>
                            <p class="update-instance-option__description">
                                Cria a Conexão na Integração Cloud com um dos fornecedores oficiais.
                            </p>

                            <div v-if="instance.is_official" class="update-instance-option__provider">
                                <span class="update-instance-option__provider-label">Fornecedor Oficial</span>

                                <div class="update-instance-option__provider-options">
                                    <vs-radio
                                        v-for="provider in officialInstanceProviders"
                                        :key="provider.value"
                                        v-model="instance.official_provider"
                                        :vs-value="provider.value"
                                        vs-name="updateOfficialProvider"
                                    >
                                        {{ provider.label }}
                                    </vs-radio>
                                </div>
                            </div>
                        </div>

                        <div class="update-instance-option">
                            <vs-checkbox v-model="instance.unlimitedInstance" size="small">
                                <span class="update-instance-option__label">Conexão Ilimitada</span>
                            </vs-checkbox>
                            <p class="update-instance-option__description">
                                Usa o tipo de conexão ilimitada no Faturamento Mensal.
                            </p>
                        </div>

                        <div
                            v-if="!instance.is_official"
                            :class="['update-instance-option', 'update-instance-option--sync', { 'update-instance-option--active': instance.use_sync }]"
                        >
                            <vs-checkbox v-model="instance.use_sync" size="small">
                                <span class="update-instance-option__label">Conexão de Ativação Cloud</span>
                            </vs-checkbox>
                            <p class="update-instance-option__description">
                                Ativa temporariamente a versão para apoio em Ativações Cloud.
                            </p>

                            <div class="update-instance-option__warning" v-if="instance.use_sync">
                                <div class="con-vs-alert no-message-alert con-vs-alert-warning">
                                    <div class="vs-alert">
                                        <p><b>Atenção:</b> use esta opção somente para Ativações Cloud.</p>
                                        <p class="mt-2">Qualquer conexão que permanecer nessa versão será trocada automaticamente.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="update-instance-section">
                        <h6 class="update-instance-section__title">Status</h6>

                        <div :class="['update-instance-option', { 'update-instance-option--disabled': instance.is_official }]">
                            <vs-checkbox :checked="instance.is_official" :disabled="instance.is_official" v-model="instance.reset_finished" size="small">
                                <span class="update-instance-option__label">Reset Finalizado</span>
                            </vs-checkbox>
                            <p class="update-instance-option__description">
                                Indica se o fluxo de reset da conexão foi concluído.
                            </p>
                        </div>

                        <div :class="['update-instance-option', { 'update-instance-option--disabled': instance.is_official }]">
                            <vs-checkbox :checked="instance.is_official" :disabled="instance.is_official" v-model="instance.activated" size="small">
                                <span class="update-instance-option__label">Conexão Ativa</span>
                            </vs-checkbox>
                            <p class="update-instance-option__description">
                                Marca a conexão como conectada.
                            </p>
                        </div>

                        <div v-if="instance.is_official" :class="['update-instance-option']">
                            <vs-checkbox  v-model="instance.is_coex" size="small">
                                <span class="update-instance-option__label">Coex</span>
                            </vs-checkbox>
                            <p class="update-instance-option__description">
                                Marca a conexão como Coex ou Convencional.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="update-instance-modal__actions">
                    <span>
                        <vs-button size="medium" color="danger" type="border" @click="closePopUpUpdate()">
                            <span> Cancelar </span>
                        </vs-button>
                    </span>
                    <span>
                        <vs-button class="ml-4" size="medium" color="success" @click="updateInstanceHttp">
                            <span> Atualizar </span>
                        </vs-button>
                    </span>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import instanceHttp from './../../http/requests/connections/index';
    import {
        DEFAULT_OFFICIAL_INSTANCE_PROVIDER,
        getOfficialProviderValueByIntegrationId,
        officialInstanceProviders
    } from './../../supports/officialInstanceProviders';
    export default {
        name: 'UpdateInstance',
        data() {
            return {
                originalInstance: {},
                officialInstanceProviders
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            instance: {
                type: Object|Array,
                required: true
            },
            token: {
                type: String,
                required: true
            }
        },
        emits: [
            'isActiveFalse',
            'successfullyUpdated'
        ],
        methods: {
            verify(){
                const permissions = localStorage.getItem('permissions');
                const twoFactor = localStorage.getItem('twoFactor')
                if(!permissions && !twoFactor){
                    this.$router.push('/user-settings')
                }else if(!permissions && twoFactor){
                    this.$router.push('/two-factor')
                }
            },
            async updateInstanceHttp() {
                const data = {
                    ...(
                        this.originalInstance.unlimitedInstance !== this.instance.unlimitedInstance
                        && { unlimitedInstance: this.instance.unlimitedInstance }
                    ),
                    ...(
                        this.originalInstance.isOfficial !== this.instance.is_official
                        && { isOfficial: this.instance.is_official }
                    ),
                    ...(
                        this.originalInstance.resetFinished !== this.instance.reset_finished
                        && { resetFinished: this.instance.reset_finished }
                    ),
                    ...(
                        this.originalInstance.activated !== this.instance.activated
                        && { activated: this.instance.activated }
                    ),
                    ...(
                        this.originalInstance.name !== this.instance.name
                        && { name: this.instance.name }
                    ),
                    ...(
                        this.originalInstance.useSync !== this.instance.use_sync
                        && { useSync: this.instance.use_sync }
                    ),
                    ...(
                        this.instance.is_official
                        && (
                            this.originalInstance.officialProvider !== this.instance.official_provider
                            || this.originalInstance.isOfficial !== this.instance.is_official
                        )
                        && { officialProvider: this.instance.official_provider }
                    ),
                    ...(
                        this.originalInstance.isCoex !== this.instance.is_coex
                        && { isCoex: this.instance.is_coex }
                    ),
                    tenantName: this.instance.tenantName,
                    id: this.instance.id
                }

                if (data.isOfficial) {
                    delete data.activated;
                    delete data.resetFinished;
                }

                if (data.name !== undefined) {
                    const response = await instanceHttp.getAllConnections(data.tenantName, this.token);
                    const hasName = response.data.find(item => item.name === data.name);

                    if (hasName) {
                        return this.$vs.notify({
                            title: 'Erro!',
                            text: 'Uma conexão com esse nome já existe!',
                            color: 'danger'
                        });
                    }
                }

                await instanceHttp.updateInstance(data, this.token)
                .then(() => {
                    this.$vs.notify({
                        title: 'Sucesso!',
                        text: 'Conexão atualizada com sucesso!',
                        color: 'success'
                    });
                    return this.$emit('successfullyUpdated');
                })
                .catch(Exception => {
                    console.log(Exception);
                    return this.$vs.notify({
                        title: 'Erro!',
                        text: 'Algo deu errado ao tentar atualizar a conexão!',
                        color: 'danger'
                    });
                });
            },
            closePopUpUpdate(){
                this.$emit('isActiveFalse');
            },
        },
        computed: {
            parsedUnlimitedInstance() {
                return this.instance.type === 'web_ilimitada'; 
            }
        },
        watch: {
            isActive(active) {
                if (active) {
                    this.$set(this.instance, 'unlimitedInstance', this.parsedUnlimitedInstance);
                    this.$set(this.instance, 'use_sync', Boolean(this.instance.use_sync));
                    this.$set(
                        this.instance,
                        'official_provider',
                        getOfficialProviderValueByIntegrationId(this.instance.integration_id)
                    );

                    Object.assign(this.originalInstance, {
                        unlimitedInstance: this.instance.unlimitedInstance,
                        isOfficial: this.instance.is_official,
                        resetFinished: this.instance.reset_finished,
                        activated: this.instance.activated,
                        name: this.instance.name,
                        useSync: this.instance.use_sync,
                        officialProvider: this.instance.official_provider,
                        isCoex: this.instance.is_coex
                    });
                }
            },
            'instance.is_official'(value) {
                if (value) {
                    this.$set(this.instance, 'use_sync', false);
                    return;
                }

                this.$set(this.instance, 'official_provider', DEFAULT_OFFICIAL_INSTANCE_PROVIDER);
            }
        },
        mounted(){
            this.verify()
        },
        created(){
            this.$events.on('closePopUpUpdate', this.closePopUpUpdate);
        },
        beforeDestroy() {
            this.$events.off('closePopUpUpdate', this.closePopUpUpdate);
        }
    }
</script>

<style lang="scss">
    #create-instance-popup {
        div.vs-popup {
            .vs-popup--content {
                padding: 18px;
                margin: 0;
            }

            margin: 0;
            border-color: rgba(18, 17, 17, 0.769);
            width: 560px !important;
        }
    }

    .update-instance-modal__header {
        margin-bottom: 16px;
    }

    .update-instance-modal__title {
        color: #4b4b4b;
        margin-bottom: 6px;
    }

    .update-instance-modal__subtitle {
        color: #7a7a7a;
        font-size: 0.92rem;
        line-height: 1.4;
        margin: 0;
    }

    .update-instance-modal__field {
        margin-bottom: 18px;
    }

    .update-instance-modal__sections {
        display: flex;
        gap: 16px;
        margin-bottom: 20px;
    }

    .update-instance-section {
        flex: 1;
        border: 1px solid #ececec;
        border-radius: 12px;
        padding: 14px;
        background: #fafafa;
    }

    .update-instance-section__title {
        color: #4a4a4a;
        font-size: 0.95rem;
        font-weight: 600;
        margin-bottom: 14px;
    }

    .update-instance-option {
        border: 1px solid #e7e7e7;
        border-radius: 10px;
        padding: 12px;
        background: #fff;
    }

    .update-instance-option + .update-instance-option {
        margin-top: 12px;
    }

    .update-instance-option--sync {
        border-color: #ffe1a8;
        background: #fffaf0;
    }

    .update-instance-option--active {
        border-color: #ffb74d;
        background: #fff6e5;
    }

    .update-instance-option--disabled {
        background: #f5f5f5;
        border-color: #e0e0e0;
    }

    .update-instance-option__label {
        color: #2f2f2f;
        font-weight: 600;
    }

    .update-instance-option__description {
        color: #6c6c6c;
        font-size: 0.88rem;
        line-height: 1.45;
        margin: 8px 0 0 28px;
    }

    .update-instance-option__warning {
        margin-top: 12px;
    }

    .update-instance-option__provider {
        margin: 12px 0 0 28px;
        padding-top: 12px;
        border-top: 1px solid #ececec;
    }

    .update-instance-option__provider-label {
        display: block;
        color: #4b4b4b;
        font-size: 0.82rem;
        font-weight: 600;
        margin-bottom: 10px;
        text-transform: uppercase;
        letter-spacing: 0.03em;
    }

    .update-instance-option__provider-options {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
    }

    .update-instance-modal__actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    @media (max-width: 768px) {
        .update-instance-modal__sections {
            flex-direction: column;
        }
    }
</style>